import { useEffect, useState } from "react";
import { TicketData, useTicketData } from "..";
import { Media } from "../../../../js/parsegenerated";

export const useMedia = (ticketId?: string) => {
  const ticketData = useTicketData(ticketId);
  const [media, setMedia] = useState<Media[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      const fetchedMedia = await fetchMedia(ticketData);
      setMedia(fetchedMedia);
      setLoading(false);

      setMedia((prev) => [...prev, ...media]);
    }
    fetch();
  }, [ticketData?.messages]);

  return { media, loading };
};

export async function fetchMedia(ticketData: TicketData): Promise<Media[]> {
  const media: Media[] = [];
  const mediaMessages = ticketData?.messages?.filter(
    (msg) => msg.get("data")?.type === "media"
  );

  for (const message of mediaMessages) {
    const fetchedMedia = (await message
      .relation("media")
      .query()
      .find()) as Media[];
    media.push(...fetchedMedia);
  }

  return media;
}
